define('models/dayPart',["T1", "T1Model"], function (T1, T1Model) {
  T1.Models.DayPart = T1Model.extend({
    url: "day_parts/"
  });
  return T1.Models.DayPart;
});
